import React from "react";
import { useTranslation } from "../i18n";
import AuthLanguageDropdown from "./AuthLanguageDropdown";

const AuthLeftColumn = () => {
  const { t, text } = useTranslation();

  return (
    <div className="col-md-6 d-none d-md-flex admin-login-left">
      <div className="admin-login-left-inner">
        <div className="admin-login-logo">
          <img src="/assets/lualilogoblack.svg" alt={t("ui.luali.commodities")} />
          <AuthLanguageDropdown inverse />
        </div>
        <div className="admin-login-left-content">
          <div className="admin-login-kicker">{text("GLOBAL COMMODITY SOLUTIONS")}</div>
          <h1>
            {text("Connecting")}
            <span>{text("Markets").toLocaleLowerCase()}</span>
            {text("Creating Opportunities").toLocaleLowerCase()}
          </h1>
          <p>{text("A trusted platform for global trade, built for suppliers, buyers and partners worldwide.")}</p>
        </div>
        <div className="admin-login-left-footer">{t("ui.2026.luali.commodities.all.rights.reserved")}</div>
      </div>
    </div>
  );
};

export default AuthLeftColumn;
